jQuery(document).ready(function ($) {

  // HOME PAGE > FAQ > MORE BUTTON
  var link = document.getElementById('home_page_faq_more_button');
  analytics.trackLink(link, 'EVENT_NAME', {
    one: 'two'
  });

  // ADD MORE HERE
  // var link = document.getElementById('home_page_faq_more_button');
  // analytics.trackLink(link, 'EVENT_NAME', {
  //   one: 'two'
  // });

  //
  //  START LEAD EVENTS
  //

  function toObject(arr) {
    var rv = {};
    for (var i = 0; i < arr.length; ++i)
      if (arr[i] !== undefined) rv[arr[i].name] = arr[i].value;
    return rv;
  }

  // put html validations
  $(this).find('input').map(function (i, field) {
    $(field).attr('required', true);
  });

  // error handling
  $("#event_form").on("ajax:error", function(xhr, data, status) {
    $("#event_form").find(".error").text("Email is invalid");
  });

  $("#event_form").on("ajax:success", function(event) {
    var data = event.detail[0];

    // get all the values from the form
    // {name: name, value: value}
    var fieldsObjectArray = $(this).find('input').map(function(i, field) {
      if (field.name) {
        return({name: field.name.replace(/nil_form/g, '').replace(/[[\]]/g,''), value: field.value})
      }
    });

    // alias
    analytics.alias(data.user_id);
    // id
    analytics.identify(data.user_id);
    // send event
    analytics.track($(this).attr('data-event-name'), Object.assign(JSON.parse($(this).attr('data-event-attr')), toObject(fieldsObjectArray)));

    // check if we have a redirect attr
    if ($(this).attr('data-success-redirect')) {
      window.location.href = $(this).attr('data-success-redirect');
    }

    // show the user that it was submitted
    $("#event_form").find(".error").text("");
    $("#event_form").find(".success_message").text($(this).attr('data-success-message'));
    $(this).find('input').attr('disabled', true);
    $(this).find('button').attr('disabled', true);
    $(this).find('button').text("DONE");
    $(this).find('button').removeClass("btn-secondary-purple-inverse");

  });

  //
  // END LEAD EVENTS
  //


});

